import { useAppDispatch } from "../../../redux/useAppDispatch";
import { openOrganizationModal, setCurrentRecord } from "../../../redux/SettingModule/UsersPage/UsersAction";

function OrganizationLink(props: any) {
  const dispatch = useAppDispatch();

  return (
    <div
      className="link"
      onClick={() => {
        dispatch(openOrganizationModal());
        dispatch(setCurrentRecord(props.record));
      }}>
      {props.data.length}
    </div>
  );
}

export default OrganizationLink;
